export function addCurrent(server) {
    return {
        type: 'ADD_CURRENT_SERVER',
        server,
    }
}
